module.exports = __webpack_public_path__ + "static/accounts_aws_1-456fda0d71e15ebec81ba4d844cce780.png";